import { CheckRounded } from '@mui/icons-material';
import styled from 'styled-components';

interface CheckmarkProps {
		size: number
}

const CheckmarkStyle = styled.div`
	height: ${(props: CheckmarkProps) => props.size}px;
	width: ${props => props.size}px;
	border-radius: 50%;
	background: #1cff76;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: ${props => props.size / 2}px;
`;

export default function Checkmark(props: CheckmarkProps) {
		return <CheckmarkStyle {...props}>
				<CheckRounded />
		</CheckmarkStyle>
}